export const LEGIT_HEALTH_APP_KEY_PREFIX = import.meta.env.VITE_LEGIT_HEALTH_APP_KEY_PREFIX;

export default function getStorageKeyPrefix() {
  return LEGIT_HEALTH_APP_KEY_PREFIX;
}
